/* Cómo se ABRE el cajón de compra · SOP-carrito.md §4.7
   Seis líneas de trabajo y un archivo entero de explicación, porque lo que arreglan no se ve.

   LO QUE HACE HORIZON (medido el 2026-09-28 sobre el tema vivo). `theme-drawer.js` decide la
   apertura en una sola línea:

       this.#modalQuery.matches ? (lockScroll(panel), panel.showModal()) : (unlockScroll(panel), panel.show())

   y `#modalQuery` es `(max-width: 989px)`. O sea: en celular el carrito abre como VENTANA —capa
   superior, velo, resto de la página inerte— y en computador abre con `show()`, que NO es modal.
   Un diálogo no modal es un div con `z-index` (medido: 8). Por eso el mega menú —`fixed`,
   ancho completo, `z-index: 19`— se lo comía, la página seguía clicable detrás y el `::backdrop`
   que se escribió el 29-sep era código muerto: sin `showModal()` no hay backdrop que animar.

   LO QUE HACE ESTE ARCHIVO. Sustituye `show()` SOLO para los diálogos que cuelgan de
   `#cart-drawer`, y ahí llama a `showModal()`. Cualquier otro `<dialog>` de la tienda —la hoja
   de tallas, la lupa de reseñas, el de una app— sigue por el camino nativo, intacto.

   POR QUÉ AL PROTOTIPO Y NO AL ELEMENTO. Horizon repinta el cajón con la Section Rendering API
   cada vez que cambia el carrito, y un parche puesto sobre el elemento se pierde en el primer
   repintado. El prototipo sobrevive a todos, sin observadores ni reintentos.

   LA CLASE ES LA LLAVE. `aud-cajon-flota` en <html> dice «este archivo está vivo», y solo con
   ella el CSS se atreve a anular el empujón de la página. Si el módulo no carga, no hay clase,
   no hay anulación, y el cajón empuja como lo dejó el tema: el fallo cae del lado seguro. Es la
   misma convención de `aud-menu-ok` en la navegación. */

(() => {
  const raiz = document.documentElement;
  const proto = window.HTMLDialogElement && HTMLDialogElement.prototype;

  /* Sin `showModal` no hay nada que ofrecer, y sin la clase puesta dos veces tampoco. */
  if (!proto || typeof proto.showModal !== 'function') return;
  if (raiz.classList.contains('aud-cajon-flota')) return;

  const nativo = { show: proto.show, modal: proto.showModal };

  proto.show = function abrirComoVentana() {
    const esDelCarrito =
      this.isConnected && typeof this.closest === 'function' && this.closest('#cart-drawer');

    if (esDelCarrito) {
      /* `showModal()` sobre un diálogo ya abierto LANZA. Y si por lo que sea no puede abrir en
         modal, se cae al `show()` de siempre: peor caso, el cajón de hoy. */
      if (this.open) return;
      try {
        nativo.modal.call(this);
        return;
      } catch (error) {
        /* cae al nativo */
      }
    }

    return nativo.show.apply(this, arguments);
  };

  raiz.classList.add('aud-cajon-flota');

  /* EL CARRITO NO SE GUARDA PARA LA PÁGINA SIGUIENTE (lección L-22, 2026-09-28).
     En computador Horizon recuerda los cajones abiertos y los reabre al navegar, poniéndoles el
     atributo `open` a mano: eso NO pasa por `show()`, así que lo de arriba no lo ve, y el
     carrito volvía como panel no modal flotando sobre una página viva. Medido: abierto el
     cajón, se navega a /collections/all y llega `open` con `:modal` en falso.
     Una ventana no se arrastra de una página a otra: quien toca un producto dentro del carrito
     quiere ver el producto. `no-persist` es el gancho que el propio Horizon trae para esto
     (`theme-drawer[open]:not([no-persist])`). La limpieza de lo ya guardado la hace un guion en
     línea de la sección, que corre antes que el de Horizon. */
  const cajon = document.getElementById('cart-drawer');
  if (!cajon) return;
  cajon.setAttribute('no-persist', '');

  /* Red: si aun así llegó restaurado, se cierra por el camino del propio componente, que es
     el que sabe soltar sus oyentes y devolverle el ancho a la página. */
  const panel = cajon.querySelector('dialog');
  if (panel && panel.open && !panel.matches(':modal') && window.customElements) {
    customElements.whenDefined('theme-drawer').then(() => {
      if (typeof cajon.close === 'function' && panel.open && !panel.matches(':modal')) cajon.close();
    });
  }
})();
